const PROGRAMMATIC = {
  PROGRAMMATIC: '/programmatic',
  PROGRAMMATIC_PROCESS: '/programmatic/:identifier',
  CREATE_MODAL: '/programmatic/create'
} as const

export default PROGRAMMATIC
